// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Utils from "../../utils/Utils.bs.js";
import * as React from "react";
import * as DateTime from "../../utils/DateTime.bs.js";
import * as Js_option from "rescript/lib/es6/js_option.js";

function rs(prim) {
  return prim;
}

function PostCard(Props) {
  var postData = Props.postData;
  var url = postData.url;
  var externalLink = url !== undefined ? React.createElement("span", {
          className: "postcard__url"
        }, "(" + Utils.get_host_from_url(url) + ")") : null;
  var score = String(postData.score);
  var timeDifference = DateTime.get_time_ago(postData.time);
  var comments = String(Js_option.getWithDefault(0, postData.descendants));
  var dot = React.createElement("div", {
        className: "postcard__dot"
      }, "·");
  var tmp;
  switch (comments) {
    case "0" :
        tmp = "No comments";
        break;
    case "1" :
        tmp = comments + " comment";
        break;
    default:
      tmp = comments + " comments";
  }
  return React.createElement("div", {
              className: "postcard"
            }, React.createElement("div", {
                  className: "postcard__score"
                }, score), React.createElement("div", {
                  className: "postcard__contents"
                }, React.createElement("div", {
                      className: "postcard__title"
                    }, React.createElement("a", {
                          href: "https://news.ycombinator.com/item?id=" + postData.id,
                          target: "_blank"
                        }, React.createElement("h3", {
                              title: "Open HN Thread"
                            }, postData.title), externalLink)), React.createElement("div", {
                      className: "postcard__meta"
                    }, React.createElement("div", {
                          className: "postcard__author"
                        }, "Posted by " + postData.by), dot, React.createElement("div", {
                          className: "postcard__time"
                        }, timeDifference), dot, React.createElement("div", {
                          className: "postcard__comments"
                        }, tmp))));
}

var make = PostCard;

export {
  rs ,
  make ,
  
}
/* react Not a pure module */
